// Zrcadlo backend politiky slozitosti hesla (uroven "stredni"). Autorita je
// backend (Dom.Api/Services/Auth/PasswordPolicy.cs) — tady mame stejna pravidla
// jen jako UX (inline validace + disable tlacitka), aby uzivatel nedostal 400
// az po odeslani. Pravidla a hlasky musi byt v synchronizaci s backendem.

export const MIN_DELKA = 8;
export const MAX_DELKA = 128;
export const MIN_KATEGORII = 3;

// Trivialni vzory — kontrola case-insensitive jako "obsahuje".
const BLACKLIST = [
  'heslo',
  'password',
  'passwd',
  'admin',
  'qwerty',
  '123456',
  '12345678',
  '111111',
  'letmein',
  'welcome',
  'dpb',
];

/**
 * Vrati seznam duvodu, proc heslo nevyhovuje. Prazdne pole = heslo je v poradku.
 * `email` je volitelny — pokud je zadany, kontroluje se, ze ho heslo neobsahuje
 * (ani jeho local-part pred @, pokud ma >= 3 znaky). Kdyz email neni k dispozici,
 * tahle kontrola se vynecha.
 */
export function kontrolaHesla(heslo: string, email?: string): string[] {
  const duvody: string[] = [];

  if (!heslo || heslo.length < MIN_DELKA) {
    duvody.push(`Heslo musí mít alespoň ${MIN_DELKA} znaků.`);
    // Bez delky nema smysl resit zbytek — vratime hned (jako backend).
    return duvody;
  }

  if (heslo.length > MAX_DELKA) {
    duvody.push(`Heslo je příliš dlouhé (max ${MAX_DELKA} znaků).`);
  }

  let maleP = false;
  let velkeP = false;
  let cislice = false;
  let special = false;
  for (const c of heslo) {
    if (c >= 'a' && c <= 'z') maleP = true;
    else if (c >= 'A' && c <= 'Z') velkeP = true;
    else if (c >= '0' && c <= '9') cislice = true;
    else if (/\p{Ll}/u.test(c)) maleP = true;
    else if (/\p{Lu}/u.test(c)) velkeP = true;
    else if (/\p{Nd}/u.test(c)) cislice = true;
    else special = true;
  }

  const kategorii = (maleP ? 1 : 0) + (velkeP ? 1 : 0) + (cislice ? 1 : 0) + (special ? 1 : 0);
  if (kategorii < MIN_KATEGORII) {
    duvody.push(
      `Heslo musí obsahovat alespoň ${MIN_KATEGORII} ze 4: malé písmeno, velké písmeno, číslici, speciální znak.`,
    );
  }

  const lower = heslo.toLowerCase();
  if (BLACKLIST.some((b) => lower.includes(b))) {
    duvody.push('Heslo je příliš triviální (obsahuje běžný vzor).');
  }

  if (email && email.trim().length > 0) {
    const emailLower = email.trim().toLowerCase();
    const local = emailLower.split('@')[0];
    if (lower === emailLower || (local.length >= 3 && lower.includes(local))) {
      duvody.push('Heslo nesmí obsahovat e-mailovou adresu.');
    }
  }

  return duvody;
}

/** Pohodlny boolean wrapper nad kontrolaHesla — true = heslo vyhovuje. */
export function hesloVyhovuje(heslo: string, email?: string): boolean {
  return kontrolaHesla(heslo, email).length === 0;
}

/** Strucny hint pod pole hesla — co se ocekava. */
export const HESLO_HINT = `Min. ${MIN_DELKA} znaků, kombinace velkých/malých písmen, číslic a speciálních znaků.`;
